import axios from 'axios'
import config from '../../utils/config'
import toast from 'react-hot-toast'

const url = config.testUrl

const create = async (obj) => {
	const response = await axios.post(`${url}/reach/contact`, obj)

	if (response.data) {
		toast.success('details has been sent!', {
			position: 'top-right',
		})
	}

	return response.data.data
}

const contactService = {
	create,
}

export default contactService
